import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { ShieldQuestion, PhoneCall, FileText, BriefcaseMedical, Phone, CalendarIcon } from 'lucide-react'
import { faQuestionCircle, faPhone, faFileText, faBriefcaseMedical, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import PatientInfoModal from "./PatientInfoModal";
//import formatDateSolicitation from "../../../utils/formatDateSolicitation";
import AuthorizationIcon from "./AuthorizationIcon";
import { formatDateDDMMYYYYHHMM } from "../utils/formats";

export default function PatientPartialCard({ patient }) {
  const [modalOpen, setModalOpen] = useState(false);

  const openWhatsApp = (whatsapp, e) => {
    e.preventDefault()
    e.stopPropagation()

    const cleanNumber = whatsapp.replace(/\D/g, "")

    // Abrir WhatsApp Web
    window.open(`https://wa.me/55${cleanNumber}`, "_blank")
  }

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const hasLgpdStatus = patient.patient.sms_status_lgpd !== undefined;
  const isAuthorized = patient.patient.sms_status_lgpd;

  return (
    <>
      <div className="patient-card">
        <div className="patient-avatar">
          <FontAwesomeIcon icon={faQuestionCircle} size="xl" />
        </div>

        <div className="patient-info" style={{ maxWidth: '60%' }}>
          <div className="patient-main-info align-items-center">
            <div className="d-flex align-items-center gap-4">

              <div className="d-flex flex-column gap-3">
                <span className="fs-6"><FontAwesomeIcon icon={faPhone} className="text-muted me-2" />
                  { patient.name }
                  {patient.patient.sms_name && `- ${patient.patient.sms_name}`}
                </span>
                <span className="fs-6"><FontAwesomeIcon icon={faBriefcaseMedical} className="text-muted me-2" /> {patient.patient.professional_name}</span>
                <p className="fw-semibold fs-6">
                  <FontAwesomeIcon icon={faCalendar} className="text-muted me-2" />{formatDateDDMMYYYYHHMM(patient.patient.date_solicitation)}
                </p>
              </div>
            </div>

            <div
              className="btn-whatsapp d-flex align-items-center justify-content-center rounded-circle text-white me-5"
              title="Contatar paciente por whatsapp"
              onClick={(e) => openWhatsApp(patient.name, e)}
            >
              <FontAwesomeIcon icon={faPhone} style={{ alignSelf: 'center' }} />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center col-3">
          <Button
            variant="outline-primary"
            size="sm"
            className="d-flex align-items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              openModal();
            }}
            disabled={!isAuthorized}
          >
            <FontAwesomeIcon icon={faFileText} />
            <span>Preencher informações</span>
          </Button>

          {hasLgpdStatus && (
            <AuthorizationIcon
              id={patient.id}
              professionalCpf={patient.patient.professional_cpf}
              professionalName={patient.patient.professional_name}
              authorized={isAuthorized}
              count={patient.patient.sms_quantity_send}
            />
          )}
        </div>
      </div>

      <PatientInfoModal
        patient={patient}
        isOpen={modalOpen}
        onClose={closeModal}
      />
    </>
  );
}